import React from 'react';
import classNames from 'classnames';

export default function InputLabel({ children, htmlFor, className = '', labelRightElement = null }) {
  const labelClassNames = classNames(
    'block text-sm/6 font-medium text-gray-100',
    className
  );

  const renderLabel = () => (
    <label htmlFor={htmlFor} className={labelClassNames}>
      {children}
    </label>
  );

  if (labelRightElement) {
    return (
      <div className="w-full flex items-center justify-between">
        {renderLabel()}
        {labelRightElement}
      </div>
    );
  }

  return renderLabel();
}
